//css-------------------
import '../../css/share/common.scss';
import '../../css/home/article_list.scss';

//fontawesome
import( /* webpackPrefetch: true */ '../../lib/fontawesome/fontawesome.scss');
import( /* webpackPrefetch: true */ '../../lib/fontawesome/regular.scss');
import( /* webpackPrefetch: true */ '../../lib/fontawesome/brands.scss');

//js----------------------
//components
import( /* webpackPrefetch: true */ '../share/components/_common');
import( /* webpackPrefetch: true */ '../share/components/_cookie');
import( /* webpackPrefetch: true */ '../share/components/_header');
import( /* webpackPrefetch: true */ '../share/components/_welcome_canvas_fog');
import( /* webpackPrefetch: true */ '../share/components/_content_scrolltrigger');

//npm lib
import $ from "jquery";
import imagesLoaded from "imagesloaded";
import { createApp } from 'vue/dist/vue.esm-browser.prod.js';

$(function () {
    const app = createApp({
        data() {
            return {

            }
        },
        mounted() {

            imagesLoaded("html, body", function () {
                $(".loading").fadeOut(function () {
                    $(this).remove();

                    $('head').append('<link rel="preconnect" href="https://fonts.googleapis.com">')
                    $('head').append('<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>')
                    $('head').append('<link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@300..800&family=Oswald:wght@200..700&display=swap" rel="stylesheet">')

                });
            });
        },
        methods: {

        },
    }).mount('#app');


});